module.exports = __webpack_public_path__ + "assets/22e4e659467b56bc404db16f11d6082a.jpg";